import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
const EXCEPTIONS: string[] = [];
export const useRouteUrlHistory = () => {
  const $ = _c(8);
  const [previousRoute, setPreviousRouter] = useState("");
  const router = useRouter();
  let t0;
  if ($[0] !== router.asPath) {
    t0 = url => {
      const [nextUrl] = url?.split("?") || [];
      if (!(EXCEPTIONS.includes(nextUrl) || EXCEPTIONS.includes(router.asPath)) && nextUrl !== router.asPath) {
        setPreviousRouter(router.asPath);
      }
    };
    $[0] = router.asPath;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleBeforeHistoryChange = t0;
  let t1;
  let t2;
  if ($[2] !== handleBeforeHistoryChange || $[3] !== router.events) {
    t1 = () => {
      router.events.on("beforeHistoryChange", handleBeforeHistoryChange);
      return () => {
        router.events.off("beforeHistoryChange", handleBeforeHistoryChange);
      };
    };
    t2 = [handleBeforeHistoryChange, router.events];
    $[2] = handleBeforeHistoryChange;
    $[3] = router.events;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== previousRoute) {
    t3 = {
      previousRoute
    };
    $[6] = previousRoute;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};